import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { scrollbarStyles } from '../../styleSheet';

import Sidebar from '../../redux/containers/layout/Sidebar';
import ContentTopBar from '../../redux/containers/layout/ContentTopBar';

function AppLayout({ getViews, getStoresData, getUserInformation }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const init = async () => {
      getUserInformation();
      getViews();
      await getStoresData();
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
      }}
    >
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          overflowX: 'hidden',
          bgcolor: 'background.default',
          ...scrollbarStyles,
        }}
      >
        <ContentTopBar onHamburgerClick={() => setMobileOpen(prev => !prev)} />
        <Box sx={{ flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default AppLayout;
